import getPageSettingsStore from 'booking-page-store/lib/store';
import {
    defaultFollowUpMessage,
    defaultFollowUpLinkText,
} from './../components/reminders-notifications/RemindersNotifications.locstring.json';
import loc from 'owa-localize';

const getDefaultFollowUpMessage = (): string => {
    const { PublishedUrl, FriendlyUrl } = getPageSettingsStore().publishingSettings;
    const url = FriendlyUrl || PublishedUrl || '';
    const updatedUrl = `${url}?RefID=FollowUpEmail`;
    const message = !!url
        ? `<div>${loc(
              defaultFollowUpMessage
          )} <a href=\"${updatedUrl}\" title=\"${updatedUrl}\" target=\"_blank\">${loc(
              defaultFollowUpLinkText
          )}</a></div>`
        : loc(defaultFollowUpMessage);
    return message;
};

export default getDefaultFollowUpMessage;
